<template>
  <div>
    <b-loading :is-full-page="true" :active.sync="isLoading"> </b-loading>
    <table :key="tableRenderKey" id="ni-ri-chem-bio-table">
      <thead>
        <tr>
          <th>Line No.</th>
          <th class="select-checkbox-cell">
            <b-checkbox
              v-model="selectAllChecked"
              type="is-info"
              size="is-large"
              title="Select All"
            ></b-checkbox>
          </th>
          <th
            v-for="columnData in regulatoryInfoChemBioFields.columns"
            :key="columnData.id"
            :class="columnData.className"
            :title="columnData.title"
            v-show="shouldShowColumn(columnData.field)"
          >
            <label>
              {{
                columnData.field === "pcnCountries"
                  ? pcnCountriesHeaderLabel
                  : columnData.label
              }}
            </label>
          </th>
        </tr>
      </thead>
      <tbody class="ni-app-ri-chem-bio-tbody">
        <tr
          v-for="(row, index) in rows"
          :key="row.id"
          :class="[
            row.itemStatus === 'Rework – Additional Data Required'
              ? 'rework-item'
              : '',
          ]"
          @click="onRowClick($event)"
          @change="!isLoading ? changeOnRow($event, index, row) : ''"
        >
          <ValidationObserver>
            <td class="line-number">{{ row.lineNumber }}</td>
            <td class="select-checkbox-cell">
              <b-checkbox
                :disabled="showSubmissionInReadOnly"
                type="is-info"
                size="is-large"
                v-model="checkboxGroup"
                @input="emitRowIds"
                :native-value="row.genlInfoId"
              ></b-checkbox>
            </td>
            <td class="line-errors">{{ row.lineErrors }}</td>
            <td class="supp-item-nbr">
              <b-input
                class="suppItemNbr"
                v-model="row.suppItemNbr"
                disabled
              ></b-input>
            </td>
            <td>
              <b-input
                class="englishPrdctNoun"
                disabled
                :value="row.englishPrdctNoun"
                :class="
                  isApiErrorField(
                    row.psfsEuNewItemGiErrTbs,
                    'englishPrdctNoun',
                    row.englishPrdctNoun
                  )
                "
              ></b-input>
            </td>
            <td>
              <b-input
                class="itemStatus"
                v-model="row.itemStatus"
                disabled
                :title="row.itemStatus"
              ></b-input>
            </td>
            <td class="hidden">
              <ValidationProvider
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="productCategory"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="productCategory"
                    v-model="row.productCategory"
                  >
                    <option value="Equipment and Instruments"
                      >Equipment and Instruments</option
                    >
                    <option value="Biologicals">Biologicals</option>
                    <option value="Chemicals and Biochemical Reagents"
                      >Chemicals and Biochemical Reagents</option
                    >
                    <option value="Consumables">Consumables</option>
                    <option value="Diagnostics">Diagnostics</option>
                    <option value="Furniture">Furniture</option>
                    <option value="Training and Services"
                      >Training and Services</option
                    >
                    <option value="Safety Products">Safety Products</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                :rules="{
                  required:
                    row.productCategory === 'Safety Products' ||
                    row.productCategory === 'Diagnostics' ||
                    row.productCategory === 'Chemicals and Biologicals' ||
                    row.productCategory === 'Biologicals'
                      ? true
                      : false,
                }"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="dangGood"
              >
                <div class="control" :class="classes">
                  <b-select
                    v-model="row.dangGood"
                    class="dangGood"
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemRichemErrTbs,
                        'dangGood',
                        row.dangGood
                      )
                    "
                    ><option value="Y">Yes</option
                    ><option value="N">No</option></b-select
                  >
                </div>
              </ValidationProvider>
            </td>
            <td>
              <a v-if="row.sdsAttachName" class="sdsAttach has-text-info">
                <span
                  :title="'Click to Download ' + row.sdsAttachName"
                  class="attachment-title download-image-attachment"
                  @click="
                    downloadSdsAttach(
                      row.sdsAttachName,
                      row.nbrNewItemCrKey,
                      row.genlInfoId
                    )
                  "
                  >{{ row.sdsAttachName }} </span
                >&nbsp;&nbsp;&nbsp;<a
                  @click="deleteSdsAttach(row.genlInfoId)"
                  class="delete-attachment"
                  title="Delete Attachment"
                >
                  <b-icon icon="delete" type="is-info" size="is-small"> </b-icon
                ></a>
              </a>
              <b-upload
                v-else
                @input="uploadSdsAttach(row.genlInfoId)"
                class="sdsAttach upload upload-attachment"
                :class="[
                  row.dangGood === 'Y' && !row.sdsAttachName ? 'invalid' : '',
                  isApiErrorField(
                    row.psfsEuNewItemRichemErrTbs,
                    'sdsAttach',
                    row.sdsAttach
                  ),
                ]"
                v-model="sdsFile"
              >
                <a class="button">
                  <span>Upload</span>
                </a>
              </b-upload>
            </td>
            <td>
              <b-input
                class="casNbr1"
                oninput="this.value = this.value.replace(/[^-?0-9]/g, '');"
                @change.native="row.casNbr1 = $event.target.value"
                :value="row.casNbr1"
                v-bind:class="[
                  row.casPct1 && !row.casNbr1 ? 'invalid' : '',
                  isApiErrorField(
                    row.psfsEuNewItemRichemErrTbs,
                    'casNbr1',
                    row.casNbr1
                  ),
                ]"
              ></b-input>
            </td>
            <td>
              <b-input
                class="casPct1"
                oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 3) this.value = this.value.split('.')[0].slice(0, 3) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                @change.native="row.casPct1 = $event.target.value"
                :value="row.casPct1"
                :class="[
                  row.casNbr1 && !row.casPct1 ? 'invalid' : '',
                  isApiErrorField(
                    row.psfsEuNewItemRichemErrTbs,
                    'casPct1',
                    row.casPct1
                  ),
                ]"
              ></b-input>
            </td>
            <td>
              <b-input
                class="casNbr2"
                oninput="this.value = this.value.replace(/[^-?0-9]/g, '');"
                @change.native="row.casNbr2 = $event.target.value"
                :value="row.casNbr2"
                v-bind:class="[
                  row.casPct2 && !row.casNbr2 ? 'invalid' : '',
                  isApiErrorField(
                    row.psfsEuNewItemRichemErrTbs,
                    'casNbr2',
                    row.casNbr2
                  ),
                ]"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                rules="max_value:100"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    class="casPct2"
                    @change.native="row.casPct2 = $event.target.value"
                    :value="row.casPct2"
                    :class="[
                      row.casNbr2 && !row.casPct2 ? 'invalid' : '',
                      isApiErrorField(
                        row.psfsEuNewItemRichemErrTbs,
                        'casPct2',
                        row.casPct2
                      ),
                    ]"
                    oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 3) this.value = this.value.split('.')[0].slice(0, 3) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-input
                class="casNbr3"
                oninput="this.value = this.value.replace(/[^-?0-9]/g, '');"
                @change.native="row.casNbr3 = $event.target.value"
                :value="row.casNbr3"
                v-bind:class="[
                  row.casPct3 && !row.casNbr3 ? 'invalid' : '',
                  isApiErrorField(
                    row.psfsEuNewItemRichemErrTbs,
                    'casNbr3',
                    row.casNbr3
                  ),
                ]"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                rules="max_value:100"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    class="casPct3"
                    @change.native="row.casPct3 = $event.target.value"
                    :value="row.casPct3"
                    :class="[
                      row.casNbr3 && !row.casPct3 ? 'invalid' : '',
                      isApiErrorField(
                        row.psfsEuNewItemRichemErrTbs,
                        'casPct3',
                        row.casPct3
                      ),
                    ]"
                    oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 3) this.value = this.value.split('.')[0].slice(0, 3) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:productCategory,Chemicals and Biochemical Reagents,Biologicals"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    class="reachNbr"
                    v-model="row.reachNbr"
                    :class="[
                      row.productCategory ===
                        'Chemicals and Biochemical Reagents' &&
                      !row.sdsAttachName &&
                      !row.reachNbr
                        ? 'invalid'
                        : '',
                      isApiErrorField(
                        row.psfsEuNewItemRichemErrTbs,
                        'reachNbr',
                        row.reachNbr
                      ),
                    ]"
                  >
                    <option value=" "></option>
                    <option value="Y">Yes</option>
                    <option value="N">No</option></b-select
                  >
                </div>
              </ValidationProvider>
            </td>
            <td v-on:keypress="typeAheadTriggered = 'unNbr'">
              <v-select
                :filterable="false"
                :taggable="false"
                :options="unNbrOptions"
                class="unNbr"
                v-bind:class="
                  isApiErrorField(
                    row.psfsEuNewItemRichemErrTbs,
                    'unNbr',
                    row.unNbr
                  )
                "
                v-model="row.unNbr"
                @search="fetchTypeAhead"
                @input="changeOnRow($event, index, row)"
                :title="row.unNbr"
              >
                <template slot="option" slot-scope="unNbrOption">
                  <div class="d-center">
                    {{ unNbrOption.label }}
                  </div>
                </template>
                <template
                  slot="selected-option"
                  slot-scope="unNbrOption"
                  title="unNbrOption"
                >
                  <div class="selected d-center">
                    {{ unNbrOption.label }}
                  </div>
                </template>
                <template slot="no-options" slot-scope="{ search, searching }">
                  <template v-if="searching">
                    Sorry, no matching options.
                  </template>
                  <span v-else class="display-none"></span>
                </template>
              </v-select>
            </td>
            <td>
              <b-select
                class="packingGroup"
                :class="
                  isApiErrorField(
                    row.psfsEuNewItemRichemErrTbs,
                    'packingGroup',
                    row.packingGroup
                  )
                "
                v-model="row.packingGroup"
                :value="
                  row.packingGroup === undefined
                    ? (row.packingGroup = ' ')
                    : row.packingGroup
                "
              >
                <option value=" "></option>
                <option>I</option>
                <option>II</option>
                <option>III</option>
              </b-select>
            </td>
            <td>
              <b-select
                class="chemicalClass"
                :class="
                  isApiErrorField(
                    row.psfsEuNewItemRichemErrTbs,
                    'chemicalClass',
                    row.chemicalClass
                  )
                "
                v-model="row.chemicalClass"
                :value="
                  row.chemicalClass === undefined
                    ? (row.chemicalClass = ' ')
                    : row.chemicalClass
                "
              >
                <option value=" "></option>
                <option>Class 1</option>
                <option>Class 2</option>
                <option>Class 3</option>
                <option>Class 4</option>
                <option>Class 5</option>
                <option>Class 6</option>
                <option>Class 7</option>
                <option>Class 8</option>
                <option>Class 9</option></b-select
              >
            </td>
            <td>
              <b-select
                class="subClass1"
                :class="[
                  row.subClass1 && row.subClass1 === row.subClass2
                    ? 'invalid'
                    : '',
                  isApiErrorField(
                    row.psfsEuNewItemRichemErrTbs,
                    'subClass1',
                    row.subClass1
                  ),
                ]"
                v-model="row.subClass1"
                :value="
                  row.subClass1 !== undefined
                    ? addPercentMode(row.subClass1)
                    : row.subClass1
                "
              >
                <option value=" "></option>
                <option>Class 1</option>
                <option>Class 2</option>
                <option>Class 3</option>
                <option>Class 4</option>
                <option>Class 5</option>
                <option>Class 6</option>
                <option>Class 7</option>
                <option>Class 8</option>
                <option>Class 9</option></b-select
              >
            </td>
            <td>
              <b-select
                class="subClass2"
                :class="[
                  row.subClass2 && row.subClass2 === row.subClass1
                    ? 'invalid'
                    : '',
                  isApiErrorField(
                    row.psfsEuNewItemRichemErrTbs,
                    'subClass2',
                    row.subClass2
                  ),
                ]"
                v-model="row.subClass2"
                :value="
                  row.subClass2 !== undefined
                    ? addPercentMode(row.subClass2)
                    : row.subClass2
                "
              >
                <option value=" "></option>
                <option>Class 1</option>
                <option>Class 2</option>
                <option>Class 3</option>
                <option>Class 4</option>
                <option>Class 5</option>
                <option>Class 6</option>
                <option>Class 7</option>
                <option>Class 8</option>
                <option>Class 9</option></b-select
              >
            </td>
            <td>
              <b-input
                class="psn1"
                @change.native="row.psn1 = $event.target.value"
                oninput='this.value = this.value.replace(/[|"]+/g, "");'
                :value="row.psn1"
                :class="[
                  row.psn1 && row.psn1 === row.psn2 ? 'invalid' : '',
                  isApiErrorField(
                    row.psfsEuNewItemRichemErrTbs,
                    'psn1',
                    row.psn1
                  ),
                ]"
              ></b-input>
            </td>
            <td>
              <b-input
                class="psn2"
                @change.native="row.psn2 = $event.target.value"
                oninput='this.value = this.value.replace(/[|"]+/g, "");'
                :value="row.psn2"
                :class="[
                  row.psn2 && row.psn2 === row.psn1 ? 'invalid' : '',
                  isApiErrorField(
                    row.psfsEuNewItemRichemErrTbs,
                    'psn2',
                    row.psn2
                  ),
                ]"
              ></b-input>
            </td>
            <td>
              <b-input
                class="techShipName"
                @change.native="row.techShipName = $event.target.value"
                oninput='this.value = this.value.replace(/[|"]+/g, "");'
                :value="row.techShipName"
                :class="
                  isApiErrorField(
                    row.psfsEuNewItemRichemErrTbs,
                    'techShipName',
                    row.techShipName
                  )
                "
              ></b-input>
            </td>
            <td>
              <b-select
                class="packageType"
                v-model="row.packageType"
                :value="
                  row.packageType === undefined
                    ? (row.packageType = ' ')
                    : row.packageType
                "
                :class="
                  isApiErrorField(
                    row.psfsEuNewItemGiErrTbs,
                    'packageType',
                    row.packageType
                  )
                "
                :title="row.packageType"
              >
                <option value=" "></option>
                <option
                  v-for="option in packageTypeOptions"
                  :value="option"
                  :key="option.id"
                  >{{ option }}</option
                >
              </b-select>
            </td>
            <td>
              <b-input
                class="density"
                @change.native="row.density = $event.target.value"
                :value="
                  row.density !== undefined
                    ? addTwoZeros(row.density)
                    : row.density
                "
                oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                :class="
                  isApiErrorField(
                    row.psfsEuNewItemRichemErrTbs,
                    'density',
                    row.density
                  )
                "
              ></b-input>
            </td>
            <td>
              <b-input
                class="flashPoint"
                @change.native="row.flashPoint = $event.target.value"
                @input.native="validateFlashPointInput"
                :value="row.flashPoint"
                :class="
                  isApiErrorField(
                    row.psfsEuNewItemRichemErrTbs,
                    'flashPoint',
                    row.flashPoint
                  )
                "
              ></b-input>
            </td>
            <td>
              <b-input
                class="ph"
                @change.native="row.ph = $event.target.value"
                :value="row.ph"
                oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{3})./g, '$1');if(this.value.split('.')[0].length > 2) this.value = this.value.split('.')[0].slice(0, 2) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                :class="
                  isApiErrorField(row.psfsEuNewItemRichemErrTbs, 'ph', row.ph)
                "
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                rules=
                "required_if:productCategory,Chemicals and Biochemical Reagents,Biologicals"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    v-model="row.byproductItem"
                    class="byproductItem"
                    :disabled="
                      row.productCategory !==
                        'Chemicals and Biochemical Reagents' &&
                        row.productCategory !== 'Biologicals'
                    "
                    :class="[
                      isApiErrorField(
                        row.psfsEuNewItemRichemErrTbs,
                        'byproductItem',
                        row.byproductItem
                      ),
                    ]"
                    ><option value="Y">Yes</option
                    ><option value="N">No</option></b-select
                  >
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                :rules="{
                  required:
                    row.productCategory === 'Safety Products' ||
                    row.productCategory === 'Diagnostics' ||
                    row.productCategory === 'Chemicals and Biologicals' ||
                    row.productCategory === 'Biologicals'
                      ? true
                      : false,
                }"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    v-model="row.biocideItem"
                    class="biocideItem"
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemRichemErrTbs,
                        'biocideItem',
                        row.biocideItem
                      )
                    "
                    ><option value="Y">Yes</option
                    ><option value="N">No</option></b-select
                  >
                </div>
              </ValidationProvider>
            </td>
            <td v-show="shouldShowColumn('ethanolPct')">
              <b-input
                class="ethanolPct"
                oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{5})./g, '$1');"
                @change.native="row.ethanolPct = $event.target.value"
                :value="
                  row.ethanolPct !== undefined
                    ? addEthanolPctMode(row.ethanolPct)
                    : row.ethanolPct
                "
                :class="
                  isApiErrorField(
                    row.psfsEuNewItemRichemErrTbs,
                    'ethanolPct',
                    row.ethanolPct
                  )
                "
              ></b-input>
            </td>
            <td v-show="shouldShowColumn('euDrugCategory')">
              <div class="control">
                <b-select
                  v-model="row.euDrugCategory"
                  :value="
                    row.euDrugCategory === undefined
                      ? (row.euDrugCategory = ' ')
                      : row.euDrugCategory
                  "
                  class="euDrugCategory"
                  :class="
                    isApiErrorField(
                      row.psfsEuNewItemRichemErrTbs,
                      'euDrugCategory',
                      row.euDrugCategory
                    )
                  "
                >
                  <option value=" "></option>
                  <option value="DP1">DP1</option>
                  <option value="DP2">DP2</option>
                  <option value="DP3">DP3</option>
                  <option value="NA">NA</option></b-select
                >
              </div>
            </td>
            <td v-show="shouldShowColumn('reachNbr17')">
              <ValidationProvider
                rules="required_if:productCategory,Chemicals and Biochemical Reagents,Biologicals"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    class="reachNbr17"
                    v-model="row.reachNbr17"
                    :class="[
                      row.productCategory ===
                        'Chemicals and Biochemical Reagents' &&
                      !row.sdsAttachName &&
                      !row.reachNbr17
                        ? 'invalid'
                        : '',
                      isApiErrorField(
                        row.psfsEuNewItemRichemErrTbs,
                        'reachNbr17',
                        row.reachNbr17
                      ),
                    ]"
                  >
                    <option value=" "></option>
                    <option value="Y">Yes</option>
                    <option value="N">No</option></b-select
                  >
                </div>
              </ValidationProvider>
            </td>
            <td>
            <div class="control">
                  <b-select
                    v-model="row.pcn"
                    class="pcn"
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemRichemErrTbs,
                        'pcn',
                        row.pcn
                      )
                    "
                    @input="onPcnChange(row, index)"
                  >
                    <option value="">Select...</option>
                    <option value="Y">Yes</option>
                    <option value="N">No</option>
                  </b-select>
                </div>
            </td>
            <td v-show="shouldShowColumn('pcnCountries')" class="pcnCountries">
              <ValidationProvider
                :rules="{
                  required: row.pcn === 'Y',
                }"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="pcnCountries"
              >
                <div class="control" :class="classes">
                  <v-select
                    v-if="row.pcn === 'Y'"
                    :key="`pcnCountries-${row.genlInfoId}-${row.pcn}`"
                    v-model="row.pcnCountries"
                    :options="euCountriesSorted"
                    multiple
                    :close-on-select="false"
                    :clear-on-select="false"
                    label="label"
                    :reduce="countryReduce"
                    class="pcnCountries"
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemRichemErrTbs,
                        'pcnCountries',
                        row.pcnCountries
                      )
                    "
                    placeholder="Select countries..."
                    :preserve-search="true"
                    @input="onCountriesChange(row, $event)"
                  >
                    <template #list-header>
                      <li
                        class="pcn-select-all-option"
                        @mousedown.prevent.stop="toggleAllCountries(row)"
                      >
                        {{ areAllCountriesSelected(row) ? 'Remove all countries' : 'Select all countries' }}
                      </li>
                    </template>
                    <template #option="option">
                      <span
                        class="pcn-country-option"
                        @mousedown.prevent.stop="toggleCountrySelection(row, option)"
                      >
                        <span
                          class="pcn-country-check"
                          :class="{ 'pcn-country-check--selected': isCountrySelected(row, option.label || option) }"
                        >{{ isCountrySelected(row, option.label || option) ? '&#10003;' : '' }}</span>
                        {{ option.label || option }}
                      </span>
                    </template>
                    <template #selected-option="option">
                      {{ option.label || option }}
                    </template>
                    <template #no-options="{ search, searching }">
                      <template v-if="searching">
                        No countries found for "{{ search }}"
                      </template>
                      <span v-else>No countries available</span>
                    </template>
                  </v-select>
                </div>
              </ValidationProvider>
            </td>
            <td v-show="shouldShowColumn('pcnUfi')" class="pcnUfi-cell">
              <ValidationProvider
                :rules="{
                  required: row.pcn === 'Y',
                  ufi_format: true,
                }"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="pcnUfi"
              >
                <div class="control" :class="classes">
                  <b-input
                    v-show="row.pcn === 'Y'"
                    v-model="row.pcnUfi"
                    class="pcnUfi"
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemRichemErrTbs,
                        'pcnUfi',
                        row.pcnUfi
                      )
                    "
                    @input="formatUfiInput(row)"
                    maxlength="19"
                    :has-counter="false"
                    placeholder="XXXX-XXXX-XXXX-XXXX"
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
          </ValidationObserver>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import vSelect from "vue-select";

Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});

// Custom UFI format validation rule
extend("ufi_format", {
  validate: (value) => {
    if (!value) return true; // Allow empty values, required rule will handle mandatory validation
    const ufiPattern = /^[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}$/i;
    return ufiPattern.test(value);
  },
  message:
    "UFI must be in format XXXX-XXXX-XXXX-XXXX (alphanumeric characters only)",
});

export default {
  name: "RegulatoryInfoChemicalBiologicalTab",
  components: { vSelect },
  data() {
    return {
      actions: [],
      checkboxGroup: [],
      isLoading: false,
      paginationParams: [],
      updateNonceByIndex: {},
      regulatoryInfoChemBioFields: {
        columns: [
          {
            className: "lineErrors",
            field: "lineErrors",
            label: "Line Errors",
            title: "Line Errors",
          },
          {
            className: "suppItemNbr",
            field: "suppItemNbr",
            label: "Supplier Item No.",
            title: "Supplier Item No.\nMax length is 25.",
          },
          {
            className: "englishPrdctNoun",
            field: "englishPrdctNoun",
            label: "English Product Description",
            title: "Product Description",
          },
          {
            className: "itemStatus",
            field: "itemStatus",
            label: "Item Status",
            title: "Item Status",
          },
          {
            className: "dangGood",
            field: "dangGood",
            label: "Is it hazardous according to CLP",
            title:
              "Is the item a hazardous following CLP for users? (Y/N) - (If Yes, provide Safety Data Sheets in PDF format )",
          },
          {
            className: "sdsAttach",
            field: "sdsAttach",
            label: "SDS file",
            title: "Attach here the SDS file",
          },
          {
            className: "casNbr1",
            field: "casNbr1",
            label: "C.A.S. Number 1",
            title: "CAS Number 1",
          },
          {
            className: "casPct1",
            field: "casPct1",
            label: "C.A.S. Number 1 Percentage",
            title: "Percentage of CAS 1",
          },
          {
            className: "casNbr2",
            field: "casNbr2",
            label: "C.A.S. Number 2",
            title: "CAS Number 2",
          },
          {
            className: "casPct2",
            field: "casPct2",
            label: "C.A.S. Number 2 Percentage",
            title: "Percentage of CAS 2",
          },
          {
            className: "casNbr3",
            field: "casNbr3",
            label: "C.A.S. Number 3",
            title: "CAS number 3",
          },
          {
            className: "casPct3",
            field: "casPct3",
            label: "C.A.S. Number 3 Percentage",
            title: "Percentage of CAS 3",
          },
          {
            className: "reachNbr",
            field: "reachNbr",
            label: "Subject to authorisation under REACH, Annex XIV",
            title: "Subject to authorisation under REACH, Annex XIV",
          },
          {
            className: "unNbr",
            field: "unNbr",
            label: "UN Number",
            title: "Current UNNR",
          },
          {
            className: "packingGroup",
            field: "packingGroup",
            label: "Packing group",
            title: "Current Packing Group",
          },
          {
            className: "chemicalClass",
            field: "chemicalClass",
            label: "Chemical Class",
            title: "Chemical Class",
          },
          {
            className: "subClass1",
            field: "subClass1",
            label: "Sub Class 1",
            title: "Sub Class",
          },
          {
            className: "subClass2",
            field: "subClass2",
            label: "Sub Class 2",
            title: "Sub Class",
          },
          {
            className: "psn1",
            field: "psn1",
            label: "Proper Shipping Name 1",
            title: "Proposer Shipping Name 1",
          },
          {
            className: "psn2",
            field: "psn2",
            label: "Proper Shipping Name 2",
            title: "Proposer Shipping Name 2",
          },
          {
            className: "techShipName",
            field: "techShipName",
            label: "Technical Shipping Name",
            title: "Technical Shipping Name",
          },
          {
            className: "packageType",
            field: "packageType",
            label: "Inner Package type",
            title:
              "Indicate for dangerous goods the package type (Drum, Plastic bottle etc.)",
          },
          {
            className: "density",
            field: "density",
            label: "Density (g/cm3)",
            title: "Product density (If the Dangerous goods is class 3)",
          },
          {
            className: "flashPoint",
            field: "flashPoint",
            label: "Flash Point (°C)",
            title: "Flash point (If the Dangerous goods is class 3) °C",
          },
          {
            className: "ph",
            field: "ph",
            label: "pH",
            title: "Acid/Base",
          },
          {
            className: "byproductItem",
            field: "byproductItem",
            label: "Animal Byproduct item?",
            title: "Animal Byproduct item?",
          },
          {
            className: "biocideItem",
            field: "biocideItem",
            label: "Biocide item?",
            title: "Biocide item?",
          },
          {
            className: "ethanolPct",
            field: "ethanolPct",
            label: "% of Ethanol",
            title: "% of Ethanol",
          },
          {
            className: "euDrugCategory",
            field: "euDrugCategory",
            label: "EU Drug Precursor Category",
            title: "EU Drug Precursor Category",
          },
          {
            className: "reachNbr17",
            field: "reachNbr17",
            label: "Subject to restriction under REACH, Annex XVII",
            title: "Subject to restriction under REACH, Annex XVII",
          },
          {
            className: "pcn",
            field: "pcn",
            label: "PCN",
            title:
              "Poison Center Notification (PCN) - Required for hazardous mixtures",
          },
          {
            className: "pcnCountries",
            field: "pcnCountries",
            label: "PCN - Countries where item can be sold",
            title: "PCN - Countries where item can be sold (EU countries)",
          },
          {
            className: "pcnUfi",
            field: "pcnUfi",
            label: "PCN - UFI",
            title:
              "PCN - Unique Formula Identifier (Format: XXXX-XXXX-XXXX-XXXX)",
          },
        ],
      },
      rowIds: [],
      rows: [],
      sdsFile: null,
      showSubmissionInReadOnly: false,
      selectAllChecked: false,
      casNbrOptions: [],
      packageTypeOptions: [],
      unNbrOptions: [],
      euCountries: [
        "Austria",
        "Belgium",
        "Bulgaria",
        "Croatia",
        "Cyprus",
        "Czech Republic",
        "Denmark",
        "Estonia",
        "Finland",
        "France",
        "Germany",
        "Greece",
        "Hungary",
        "Iceland",
        "Ireland",
        "Italy",
        "Latvia",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Malta",
        "Netherlands",
        "Norway",
        "Poland",
        "Portugal",
        "Romania",
        "Slovakia",
        "Slovenia",
        "Spain",
        "Sweden",
      ],
      // Tracks how many rows have at least one PCN country selected
      pcnCountriesSelectedCount: 0,
      // Track column visibility for better reactivity
      columnVisibility: {
        pcnCountries: false,
        pcnUfi: false,
      },
      // Used to force table re-render when layout needs recalculating
      tableRenderKey: 0,
    };
  },
  props: ["riCbTabSubmissionID", "loadRiCbTabData", "resetCheckboxSelection"],
  watch: {
    loadRiCbTabData(value) {
      if (value.loadDetails) {
        this.actions = value.actions;
        this.paginationParams = value.paginationParams;
        this.loadTabItemDetails();
      }
    },
    selectAllChecked: function(isChecked) {
      if (isChecked) {
        this.checkboxGroup = this.rowIds;
      } else {
        this.checkboxGroup = [];
      }
      this.emitRowIds();
    },
    resetCheckboxSelection() {
      this.checkboxGroup = [];
    },
    // React to any changes within rows (including nested pcnCountries arrays)
    rows: {
      handler() {
        this.recalcPcnCountriesSelectedCount();
      },
      deep: true,
    },
  },
  computed: {
    euCountriesSorted() {
      // Return a locale-aware alphabetically sorted copy of EU countries
      return (this.euCountries || [])
        .slice()
        .sort((a, b) => a.localeCompare(b));
    },
    pcnCountriesHeaderLabel() {
      // If any row has one or more PCN countries selected, show the clearer header text
      return this.pcnCountriesSelectedCount > 0
        ? "Countries where PCN notification have been completed"
        : "PCN - Countries where item can be sold";
    },
    showPcnColumns() {
      // Show PCN columns if any row has PCN = 'Y'
      return this.rows.some((row) => row.pcn === "Y");
    },
  },
  mounted() {
    this.loadPackageTypeOptions();
    // Initialize the header state on mount
    this.recalcPcnCountriesSelectedCount();
    // Initialize column visibility
    this.updateColumnVisibility();
  },
  methods: {
    normalizeFlashPoint(value) {
      if (value === null || value === undefined) return '';
      let str = String(value).trim();
      if (str === '') return '';
      // Remove decimal part
      str = str.split('.')[0];
      // Retain optional leading '-'
      const negative = str.startsWith('-');
      // Strip non-digits
      str = str.replace(/[^0-9-]/g,'');
      // Remove all '-' except possibly leading
      str = (negative ? '-' : '') + str.replace(/-/g,'');
      let digits = negative ? str.slice(1) : str;
      digits = digits.replace(/[^0-9]/g,'');
      if (digits.length > 14) digits = digits.slice(0,14);
      if (digits.length === 0) return '';
      return (negative ? '-' : '') + digits;
    },
    validateFlashPointInput(e) {
      // Allow optional leading '-' and digits only, no decimals. Max 14 digits (excluding sign).
      let v = e.target.value;
      v = v.replace(/[^0-9-]/g,'');
      // If '-' appears not at start, remove extra '-'
      if (v.indexOf('-') > 0) v = v.replace(/-/g,'');
      if (v.startsWith('-')) {
        let digits = v.slice(1).replace(/[^0-9]/g,'');
        if (digits.length > 14) digits = digits.slice(0,14);
        v = '-' + digits; // allow lone '-'
      } else {
        // Positive number path
        if (v.length > 14) v = v.slice(0,14);
      }
      e.target.value = v;
    },
    countryReduce(option) {
      // Normalize option to string label for storage
      if (typeof option === "string") return option;
      if (!option) return "";
      return option.label || option.value || option.name || "";
    },
    isCountrySelected(row, countryLabel) {
      if (!Array.isArray(row.pcnCountries) || !row.pcnCountries.length) return false;
      return row.pcnCountries.some(
        (c) => (typeof c === "string" ? c : this.countryReduce(c)) === countryLabel
      );
    },
    toggleCountrySelection(row, option) {
      const value = option.label || option;
      const current = Array.isArray(row.pcnCountries) ? row.pcnCountries.slice() : [];
      const idx = current.findIndex(
        (c) => (typeof c === "string" ? c : this.countryReduce(c)) === value
      );
      if (idx > -1) {
        current.splice(idx, 1);
      } else {
        current.push(value);
      }
      const sorted = current.slice().sort((a, b) => `${a}`.localeCompare(`${b}`));
      this.$set(row, "pcnCountries", sorted);
      const rowIndex = this.rows.findIndex((r) => r.genlInfoId === row.genlInfoId);
      if (rowIndex > -1) {
        this.changeOnRow(null, rowIndex, row);
      }
      this.recalcPcnCountriesSelectedCount();
    },
    areAllCountriesSelected(row) {
      if (!Array.isArray(row.pcnCountries)) return false;
      return row.pcnCountries.length === this.euCountriesSorted.length;
    },
    toggleAllCountries(row) {
      let newCountries;
      if (this.areAllCountriesSelected(row)) {
        newCountries = [];
      } else {
        newCountries = this.euCountriesSorted.map(
          (c) => (typeof c === "string" ? c : c.label || c)
        );
      }
      const sorted = newCountries.slice().sort((a, b) => `${a}`.localeCompare(`${b}`));
      this.$set(row, "pcnCountries", sorted);
      const rowIndex = this.rows.findIndex((r) => r.genlInfoId === row.genlInfoId);
      if (rowIndex > -1) {
        this.changeOnRow(null, rowIndex, row);
      }
      this.recalcPcnCountriesSelectedCount();
    },
    addTwoZeros(value) {
      return parseFloat(value).toFixed(
        Math.max(((value + "").split(".")[1] || "").length, 2)
      );
    },
    addPercentMode(value) {
      return parseFloat(value).toFixed(
        Math.max(((value + "").split(".")[1] || "").length, 4)
      );
    },
    addEthanolPctMode(value) {
      return parseFloat(value).toFixed(
        Math.max(((value + "").split(".")[1] || "").length, 5)
      );
    },
    changeOnRow(event, index, rowData) {
      var rowArrayFromResponse = JSON.parse(
        sessionStorage.getItem("riCbEuRows")
      );
      if (rowArrayFromResponse && rowArrayFromResponse.length > 0) {
        var rowDataFromResponseObj = JSON.parse(
          sessionStorage.getItem("riCbEuRows")
        )[index];
        for (var key in (rowDataFromResponseObj, rowData)) {
          if (
            key !== "psfsEuNewItemRichemErrTbs" &&
            key !== "lineNumber" &&
            rowDataFromResponseObj[key] !== rowData[key]
          ) {
            if (
              !(
                rowDataFromResponseObj[key] === undefined &&
                rowData[key] === " "
              )
            ) {
              if (rowData[key] === " ") {
                rowData[key] = "";
              }
              this.updateRiCbItem(rowData, index);
              break;
            }
          }
        }
      }
    },
    deleteSdsAttach(genlQstnId) {
      var scope = this;
      scope.isLoading = true;
      scope
        .$http({
          url: `${process.env.VUE_APP_API_BASE_DOMAIN}eu/deleteAttachment?genlInfoId=${genlQstnId}&attachmentName=sdsAttach`,
          method: "delete",
        })
        // eslint-disable-next-line no-unused-vars
        .then(function(response) {
          scope.isLoading = false;
          scope.$buefy.dialog.alert({
            message: `Delete SDS File action successful.`,
            confirmText: "OK",
            type: "is-success",
            onConfirm: () => scope.loadTabItemDetails(),
          });
        })
        .catch(function(error) {
          scope.isLoading = false;
          scope.$buefy.dialog.alert({
            message: `A problem occured with delete action. Please clear the cache and try again. If the problems persists, please contact the New Item Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger",
          });
        });
    },
    downloadSdsAttach(sdsAttachName, nbrNewItemCrKey, genlInfoId) {
      var scope = this;
      scope.isLoading = true;
      scope
        .$http({
          url: `${process.env.VUE_APP_API_BASE_DOMAIN}eu/downloadAttachment?nbrNewItemCrKey=${nbrNewItemCrKey}&attachmentName=sdsAttach&documentName=${sdsAttachName}&genlInfoId=${genlInfoId}`,
          method: "GET",
          responseType: "blob",
        })
        .then(function(response) {
          scope.isLoading = false;
          var url = window.URL.createObjectURL(new Blob([response.data]));
          var link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", sdsAttachName);
          document.body.appendChild(link);
          link.click();
        })
        .catch(function(error) {
          scope.isLoading = false;
          scope.$buefy.dialog.alert({
            message: `A problem occurred with SDS File download. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger",
          });
        });
    },
    emitRowIds() {
      this.$emit("riCbIdsForUpload", this.checkboxGroup);
    },
    fetchTypeAhead(search, loading) {
      if (search.length > 0) {
        var scope = this;

        loading(true);
        scope.$http
          .get(
            `${process.env.VUE_APP_API_BASE_DOMAIN}eu/loadTypeaheadsCodes?fieldName=${scope.typeAheadTriggered}&code=${search}`
          )
          .then(function(response) {
            loading(false);
            switch (scope.typeAheadTriggered) {
              case "casNbrs":
                scope.casNbrOptions = response.data;
                break;
              case "packageType":
                scope.packageTypeOptions = response.data;
              case "unNbr":
                scope.unNbrOptions = response.data;
                break;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch(function(error) {
            loading(false);
            scope.$buefy.dialog.alert({
              message: `Failed to load matching results. Please enter valid search criteria and/or clear the cache and try again. If the problem persists, please contact the New Item Support at NewItem.IT.Support@thermofisher.com`,
              confirmText: "OK",
              type: "is-danger",
            });
          });
      }
    },
    // eslint-disable-next-line no-unused-vars
    isApiErrorField(errorFieldNames, className, value) {
      if (errorFieldNames && errorFieldNames.length > 0) {
        for (var i = 0; i < errorFieldNames.length; i++) {
          let errorFieldName = errorFieldNames[i].columnName;

          // Field name mapping for PCN and other special cases
          const fieldMappings = {
            PCN: "pcn",
            PCN_COUNTRIES: "pcnCountries",
            PCN_UFI: "pcnUfi",
            CAS_NBR_1: "casNbr1",
            CAS_NBR_2: "casNbr2",
            CAS_NBR_3: "casNbr3",
            CAS_PCT_1: "casPct1",
            CAS_PCT_2: "casPct2",
            CAS_PCT_3: "casPct3",
            REACH_NBR: "reachNbr",
            REACH_NBR_17: "reachNbr17",
            UN_NBR: "unNbr",
            PSN1: "psn1",
            PSN2: "psn2",
            BYPRODUCT_ITEM: "byproductItem",
            BIOCIDE_ITEM: "biocideItem",
            DANG_GOOD: "dangGood",
            SDS_ATTACH_NAME: "sdsAttach",
          };

          // Check if the error field name matches the class name directly
          if (errorFieldName.toLowerCase() === className.toLowerCase()) {
            return "api-error";
          }

          // Check using field mapping
          if (fieldMappings[errorFieldName] === className) {
            return "api-error";
          }

          // Original logic: split by space and remove underscores
          let normalizedErrorName = errorFieldName
            .split(" ")[0]
            .replace(/_/g, "")
            .toLowerCase();

          if (normalizedErrorName === className.toLowerCase()) {
            return "api-error";
          }
        }
      }
    },
    onRowClick(event) {
      var tableRows = event.target.closest("tr").parentElement.rows;
      for (var row in tableRows) {
        if (
          tableRows[row].classList &&
          tableRows[row].classList.contains("highlight-row")
        ) {
          tableRows[row].classList.remove("highlight-row");
        }
      }
      event.target.closest("tr").classList.add("highlight-row");
    },
    loadPackageTypeOptions() {
      var scope = this;

      scope.isLoading = true;
      scope.$http
        .get(
          `${process.env.VUE_APP_API_BASE_DOMAIN}eu/DropDownValues?fieldName=packageType`
        )
        // eslint-disable-next-line no-unused-vars
        .then(function(response) {
          scope.isLoading = false;
          scope.packageTypeOptions = response.data;
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          scope.isLoading = false;
          scope.$buefy.snackbar.open({
            duration: 5000,
            message: `Failed to load Package Type options. Please try again later. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            type: "is-danger",
            position: "is-top",
            queue: false,
          });
        });
    },
    loadTabItemDetails() {
      var scope = this;
      scope.isLoading = true;
      var args = {
        headers: {
          "content-type": "application/json",
        },
      };

      var requestPayload = {};
      requestPayload.actions = [];
      requestPayload.filterMap = {};
      requestPayload.searchMap = {};
      requestPayload.sortMap = {};
      if (
        this.actions.fErrors ||
        this.actions.fSuppItemNbr ||
        this.actions.fProductNoun ||
        this.actions.fDangGood ||
        this.actions.fReworkItem
      ) {
        requestPayload.actions.push("Filter");
        requestPayload.filterMap = {};
        if (this.actions.fErrors) {
          requestPayload.filterMap.ErroredItems = this.actions.fErrors;
        }
        if (this.actions.fSuppItemNbr) {
          requestPayload.filterMap.suppItemNbr = this.actions.fSuppItemNbr;
        }
        if (this.actions.fProductNoun) {
          requestPayload.filterMap.englishPrdctNoun = this.actions.fProductNoun;
        }
        if (this.actions.fDangGood) {
          requestPayload.filterMap.dangGood = this.actions.fDangGood;
        }
        if (this.actions.fReworkItem) {
          requestPayload.filterMap.itemStatus = "K";
        }
      }
      if (this.actions.sortSuppItemNbr) {
        requestPayload.actions.push("Sort");
        requestPayload.sortMap = {};
        requestPayload.sortMap.suppItemNbr = this.actions.sortSuppItemNbr;
      }
      if (this.actions.srFieldName && this.actions.srFieldValue) {
        requestPayload.actions.push("Search");
        requestPayload.searchMap = {};
        requestPayload.searchMap[
          this.actions.srFieldName
        ] = this.actions.srFieldValue;
      }

      scope.$http
        .post(
          `${process.env.VUE_APP_API_BASE_DOMAIN}eu/getRiChemicalInfo?nbrNewItemCrKey=${scope.riCbTabSubmissionID}&pageIndex=${scope.paginationParams.pageIndex}&noOfRecords=${scope.paginationParams.numberOfItems}`,
          requestPayload,
          args
        )
        .then(function(response) {
          var riCbPaginationParams = {
            startIndex: response.data.startIndex,
            endIndex: response.data.endIndex,
            totalCount: response.data.totalCount,
            totalPages: response.data.totalPages,
          };
          scope.$emit("riCbPaginationParams", riCbPaginationParams);
          scope.$emit("ricbCount", {
            totalErrorCount: response.data.errorCount,
            tabErrorCount: response.data.riChemTabErrorCount,
          });

          //check supplier validate value
          if (sessionStorage.getItem("se_ni_user_eu")) {
            if (response.data.validateForm === "Y") {
              scope.$emit("disableSupplierValidateFromTab", true);
            } else {
              scope.$emit("enableSupplierValidateFromTab", true);
            }
          }

          scope.isLoading = false;
          scope.rows = [];
          scope.rowIds = [];
          var mutableResponseRows = response.data.psfsEuNewItemRiChemTbs;
          if (requestPayload.actions.length > 0) {
            if (response.data.psfsEuNewItemRiChemTbs.length > 0) {
              for (
                var i = 0, lineNumber = riCbPaginationParams.startIndex;
                i < mutableResponseRows.length && lineNumber > 0;
                i++, lineNumber++
              ) {
                scope.rowIds.push(mutableResponseRows[i].genlInfoId);
                mutableResponseRows[i].lineNumber = lineNumber;
                // Sanitize flashPoint to signed integer-only
                mutableResponseRows[i].flashPoint = scope.normalizeFlashPoint(mutableResponseRows[i].flashPoint);

                // Initialize PCN-related fields if not present
                if (!mutableResponseRows[i].pcn) {
                  mutableResponseRows[i].pcn = null;
                }
                if (!mutableResponseRows[i].pcnCountries) {
                  mutableResponseRows[i].pcnCountries = [];
                }
                if (!mutableResponseRows[i].pcnUfi) {
                  mutableResponseRows[i].pcnUfi = null;
                }
                // Normalize PCN countries string from API into an array for the UI multi-select
                if (
                  typeof mutableResponseRows[i].pcnCountries === "string" &&
                  mutableResponseRows[i].pcnCountries
                ) {
                  mutableResponseRows[i].pcnCountries = mutableResponseRows[
                    i
                  ].pcnCountries
                    .split(",")
                    .map((s) => s.trim())
                    .filter((s) => s)
                    .sort((a, b) => a.localeCompare(b));
                }
              }
              scope.rows = mutableResponseRows;
              sessionStorage.setItem(
                "riCbEuRows",
                JSON.stringify(response.data.psfsEuNewItemRiChemTbs)
              );
              // Update column visibility after loading rows
              scope.$nextTick(() => {
                scope.updateColumnVisibility();
                scope.recalcPcnCountriesSelectedCount();
              });
            } else {
              scope.rows = [];
              scope.rowIds = [];
            }
          } else {
            if (response.data.psfsEuNewItemRiChemTbs.length > 0) {
              for (
                var j = 0, lineNumberJ = riCbPaginationParams.startIndex;
                j < mutableResponseRows.length && lineNumberJ > 0;
                j++, lineNumberJ++
              ) {
                scope.rowIds.push(mutableResponseRows[j].genlInfoId);
                mutableResponseRows[j].lineNumber = lineNumberJ;
                // Sanitize flashPoint to signed integer-only
                mutableResponseRows[j].flashPoint = scope.normalizeFlashPoint(mutableResponseRows[j].flashPoint);

                // Initialize PCN-related fields if not present
                if (!mutableResponseRows[j].pcn) {
                  mutableResponseRows[j].pcn = null;
                }
                if (!mutableResponseRows[j].pcnCountries) {
                  mutableResponseRows[j].pcnCountries = [];
                }
                if (!mutableResponseRows[j].pcnUfi) {
                  mutableResponseRows[j].pcnUfi = null;
                }
                // Normalize PCN countries string from API into an array for the UI multi-select
                if (
                  typeof mutableResponseRows[j].pcnCountries === "string" &&
                  mutableResponseRows[j].pcnCountries
                ) {
                  mutableResponseRows[j].pcnCountries = mutableResponseRows[
                    j
                  ].pcnCountries
                    .split(",")
                    .map((s) => s.trim())
                    .filter((s) => s)
                    .sort((a, b) => a.localeCompare(b));
                }
              }
              scope.rows = mutableResponseRows;
              sessionStorage.setItem(
                "riCbEuRows",
                JSON.stringify(response.data.psfsEuNewItemRiChemTbs)
              );
              // Update column visibility after loading rows
              scope.$nextTick(() => {
                scope.updateColumnVisibility();
                scope.recalcPcnCountriesSelectedCount();
              });
            } else {
              scope.rows = [];
              scope.rowIds = [];
              sessionStorage.removeItem("rows");
            }
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          scope.isLoading = false;
          scope.$buefy.snackbar.open({
            duration: 5000,
            message: `Failed to load items for Submission - ${scope.submissionIdForRegulatoryInformation}. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            type: "is-danger",
            position: "is-top",
            queue: false,
          });
        });
    },
    updateRiCbItem(requestPayload, index) {
      var scope = this;
      var args = {
        headers: {
          "content-type": "application/json",
        },
      };

      // Use a nonce per-row to avoid race conditions from rapid updates
      const nonce = Date.now();
      this.updateNonceByIndex[index] = nonce;

      // createdBy info
      if (sessionStorage.getItem("se_ni_user_eu")) {
        requestPayload.createdBy = JSON.parse(
          sessionStorage.getItem("se_ni_user_eu")
        ).networkId;
      } else if (window.$cookies && window.$cookies.get("ni_key")) {
        requestPayload.createdBy = window.$cookies.get("ni_key").networkId;
      }

      // Build payload, always include PCN fields
      var updatedRowData = {};

      // Normalize PCN fields
      // Treat empty string as null for PCN
      const pcn =
        requestPayload.pcn !== undefined && requestPayload.pcn !== ""
          ? requestPayload.pcn
          : null;
      let countries = requestPayload.pcnCountries;
      let countriesStr = "";
      if (Array.isArray(countries)) {
        countriesStr = countries
          .map((c) =>
            typeof c === "string"
              ? c
              : (c && (c.label || c.value || c.name)) || ""
          )
          .filter((v) => v && v.toString().trim() !== "")
          .join(", ");
      } else if (typeof countries === "string") {
        countriesStr = countries;
      }
      // Treat empty string as null for UFI
      const pcnUfi =
        requestPayload.pcnUfi !== undefined && requestPayload.pcnUfi !== ""
          ? requestPayload.pcnUfi
          : null;

      // Copy other fields (exclude UI-only and error arrays); keep non-empty strings
      for (var key in requestPayload) {
        if (
          key === "psfsEuNewItemRichemErrTbs" ||
          key === "psfsEuNewItemGiErrTbs" ||
          key === "lineNumber" ||
          key === "pcn" ||
          key === "pcnCountries" ||
          key === "pcnUfi"
        ) {
          continue;
        }
        var prop = requestPayload[key];
        if (typeof prop === "string") {
          if (prop.trim() !== "") {
            updatedRowData[key] = requestPayload[key];
          }
        } else {
          updatedRowData[key] = requestPayload[key];
        }
      }

      // Normalize and include flashPoint as signed integer if present
      if ("flashPoint" in requestPayload) {
        const fpNorm = this.normalizeFlashPoint(requestPayload.flashPoint);
        if (fpNorm !== '') {
          const intVal = parseInt(fpNorm, 10);
          if (!isNaN(intVal)) {
            updatedRowData.flashPoint = intVal;
          }
        } else {
          delete updatedRowData.flashPoint;
        }
      }

      // Always include PCN fields, even when empty, and ensure proper formatting
      updatedRowData.pcn = pcn; // null, 'Y' or 'N'
      // Backend expects comma-separated string; when PCN is null/empty or 'N', send empty string
      updatedRowData.pcnCountries = pcn === "Y" ? countriesStr : "";
      updatedRowData.pcnUfi = pcn === "Y" ? pcnUfi : null;

      scope.isLoading = true;
      scope.$http
        .put(
          `${process.env.VUE_APP_API_BASE_DOMAIN}eu/updateRiChemicalInfo?nbrNewItemCrKey=${scope.riCbTabSubmissionID}`,
          updatedRowData,
          args
        )
        // eslint-disable-next-line no-unused-vars
        .then(function(response) {
          // Ignore stale responses
          if (scope.updateNonceByIndex[index] !== nonce) {
            return;
          }
          scope.isLoading = false;
          var apiRow = response.data;
          // Ensure PCN appears in UI state even if backend omits nulls
          if (apiRow.pcn === undefined) {
            apiRow.pcn = null;
          }
          apiRow.lineNumber = scope.rows[index].lineNumber;

          // Normalize API response PCN fields back to UI representation
          if (!apiRow.pcn || apiRow.pcn === "N") {
            apiRow.pcnCountries = [];
            apiRow.pcnUfi = null;
          } else {
            if (typeof apiRow.pcnCountries === "string") {
              apiRow.pcnCountries = apiRow.pcnCountries
                .split(",")
                .map((s) => s.trim())
                .filter((s) => s)
                .sort((a, b) => a.localeCompare(b));
            }
          }

          // Merge API row into existing row to preserve in-progress selections
          var currentUiRow = scope.rows[index] || {};
          var mergedRow = { ...currentUiRow, ...apiRow };
          if (Array.isArray(requestPayload.pcnCountries)) {
            mergedRow.pcnCountries = requestPayload.pcnCountries.slice();
          }
          if (
            typeof requestPayload.pcnUfi === "string" &&
            requestPayload.pcnUfi !== ""
          ) {
            mergedRow.pcnUfi = requestPayload.pcnUfi;
          }

          scope.rows[index] = mergedRow;
          var riCbEuRows = JSON.parse(sessionStorage.getItem("riCbEuRows"));
          if (riCbEuRows && Array.isArray(riCbEuRows)) {
            riCbEuRows.splice(index, 1, scope.rows[index]);
            sessionStorage.setItem("riCbEuRows", JSON.stringify(riCbEuRows));
          }
          scope.$emit("ricbCount", {
            totalErrorCount: response.data.errorCount,
            tabErrorCount: response.data.riChemTabErrorCount,
          });
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          scope.isLoading = false;
          scope.$buefy.snackbar.open({
            duration: 5000,
            message: `Failed to update item information for Submission - ${scope.riCbTabSubmissionID}. Please check for invalid data and/or clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            type: "is-danger",
            position: "is-top",
            queue: false,
          });
        })
        .then(function() {
          var tableRows = document.querySelector(".ni-app-ri-chem-bio-tbody")
            .rows;
          for (var row in tableRows) {
            if (
              tableRows[row].classList &&
              tableRows[row].classList.contains("highlight-row")
            ) {
              tableRows[row].classList.remove("highlight-row");
            }
          }
          // add highlight-row class
          document
            .querySelector(".ni-app-ri-chem-bio-tbody")
            .rows[index].classList.add("highlight-row");
          // blur select event on active element wrt index
          if (
            document.activeElement.closest("tr") &&
            document.activeElement.closest("tr").rowIndex !== index + 1
          ) {
            document.activeElement.blur();
          }
        });
    },
    // updateRiCbItem(requestPayload, index) {
    //   var scope = this;
    //   var args = {
    //     headers: {
    //       "content-type": "application/json",
    //     },
    //   };

    //   if (sessionStorage.getItem("se_ni_user_eu")) {
    //     requestPayload.createdBy = JSON.parse(
    //       sessionStorage.getItem("se_ni_user_eu")
    //     ).networkId;
    //   } else {
    //     requestPayload.createdBy = window.$cookies.get("ni_key").networkId;
    //   }

    //   var updatedRowData = {};

    //   for (var key in requestPayload) {
    //     var prop = "";
    //     prop = requestPayload[key];
    //     if (typeof prop === "string") {
    //       if (prop.trim() !== "") {
    //         updatedRowData[key] = requestPayload[key];
    //       }
    //     } else {
    //       updatedRowData[key] = requestPayload[key];
    //     }
    //   }

    //   scope.isLoading = true;
    //   scope.$http
    //     .put(
    //       `${process.env.VUE_APP_API_BASE_DOMAIN}eu/updateRiChemicalInfo?nbrNewItemCrKey=${scope.riCbTabSubmissionID}`,
    //       updatedRowData,
    //       args
    //     )
    //     // eslint-disable-next-line no-unused-vars
    //     .then(function(response) {
    //       scope.isLoading = false;
    //       var apiRow = response.data;
    //       apiRow.lineNumber = scope.rows[index].lineNumber;
    //       scope.rows[index] = apiRow;
    //       var riCbEuRows = JSON.parse(sessionStorage.getItem("riCbEuRows"));
    //       riCbEuRows.splice(index, 1, response.data);
    //       sessionStorage.setItem("riCbEuRows", JSON.stringify(riCbEuRows));
    //       scope.$emit("ricbCount", {
    //         totalErrorCount: response.data.errorCount,
    //         tabErrorCount: response.data.riChemTabErrorCount,
    //       });
    //     })
    //     // eslint-disable-next-line no-unused-vars
    //     .catch(function(error) {
    //       scope.isLoading = false;
    //       scope.$buefy.snackbar.open({
    //         duration: 5000,
    //         message: `Failed to update item information for Submission - ${scope.giTabSubmissionID}. Please check for invalid data and/or clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
    //         type: "is-danger",
    //         position: "is-top",
    //         queue: false,
    //       });
    //     })
    //     .then(function() {
    //       var tableRows = document.querySelector(".ni-app-ri-chem-bio-tbody")
    //         .rows;
    //       for (var row in tableRows) {
    //         if (
    //           tableRows[row].classList &&
    //           tableRows[row].classList.contains("highlight-row")
    //         ) {
    //           tableRows[row].classList.remove("highlight-row");
    //         }
    //       }
    //       //add highlight-row class
    //       document
    //         .querySelector(".ni-app-ri-chem-bio-tbody")
    //         .rows[index].classList.add("highlight-row");
    //       //blur select event on active element wrt index
    //       if (
    //         document.activeElement.closest("tr") &&
    //         document.activeElement.closest("tr").rowIndex !== index + 1
    //       ) {
    //         document.activeElement.blur();
    //       }
    //     });
    // },
    uploadSdsAttach(genlInfoId) {
      var scope = this;
      var isUploadValid = /^.*\.(pdf|xls|xlsx)$/.test(
        this.sdsFile.name.toLowerCase()
      );
      if (isUploadValid) {
        var args = {
          headers: {
            "content-type": "form-data",
          },
        };
        var uploadData = new FormData();
        uploadData.append("sdsAttach", scope.sdsFile);

        scope.isLoading = true;
        scope.$http
          .post(
            `${process.env.VUE_APP_API_BASE_DOMAIN}eu/uploadItemLevelAttachments?genlInfoId=${genlInfoId}`,
            uploadData,
            args
          )
          // eslint-disable-next-line no-unused-vars
          .then(function(response) {
            scope.isLoading = false;
            scope.sdsFile = null;
            scope.$buefy.dialog.alert({
              message: `SDS File upload successful.`,
              confirmText: "OK",
              type: "is-success",
              onConfirm: () => scope.loadTabItemDetails(),
            });
          })
          .catch(function(error) {
            scope.isLoading = false;
            scope.$buefy.dialog.alert({
              message: `A problem occurred with the attachment used. Please ensure attachment has the one of the following extensions: pdf, png, jpg, eps, tiff and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
              confirmText: "OK",
              type: "is-danger",
              onConfirm: () => (scope.sdsFile = null),
            });
          });
      } else {
        scope.$buefy.dialog.alert({
          message: `"${scope.sdsFile.name}" - Invalid file type, system accepts only pdf, xls, xlsx format.`,
          confirmText: "OK",
          type: "is-danger",
          onConfirm: () => (scope.sdsFile = null),
        });
      }
    },
    // PCN-related methods
    shouldShowColumn(fieldName) {
      // Show PCN countries and UFI columns only if any row has PCN = 'Y'
      if (fieldName === "pcnCountries" || fieldName === "pcnUfi") {
        return this.showPcnColumns;
      }
      return true; // Show all other columns by default
    },
    updateColumnVisibility() {
      // Update column visibility state
      this.columnVisibility.pcnCountries = this.showPcnColumns;
      this.columnVisibility.pcnUfi = this.showPcnColumns;
      // Force table reflow so header/body stay aligned when columns appear/disappear
      this.tableRenderKey += 1;
    },
    onPcnChange(row, index) {
      // Clear PCN-related fields when PCN is set to 'N'
      if (!row.pcn || row.pcn === "N") {
        row.pcnCountries = [];
        row.pcnUfi = null;
      }
      // Initialize arrays if needed
      if (row.pcn === "Y" && !row.pcnCountries) {
        this.$set(row, "pcnCountries", []);
      }

      // Update column visibility
      this.updateColumnVisibility();

      // Use nextTick to ensure DOM updates before triggering change
      this.$nextTick(() => {
        // Trigger change detection for the row
        this.changeOnRow(null, index, row);
        // Update header state
        this.recalcPcnCountriesSelectedCount();
      });
    },
    onCountriesChange(row, selectedCountries) {
      // Ensure the countries array is properly set
      if (!selectedCountries) {
        selectedCountries = [];
      }
      // Sort selections alphabetically for consistent display
      const sorted = selectedCountries.slice().sort((a, b) => `${a}`.localeCompare(`${b}`));

      // Update the row data
      this.$set(row, "pcnCountries", sorted);

      // Trigger change detection
      const rowIndex = this.rows.findIndex(
        (r) => r.genlInfoId === row.genlInfoId
      );
      if (rowIndex > -1) {
        this.changeOnRow(null, rowIndex, row);
      }
      // Update header state
      this.recalcPcnCountriesSelectedCount();
    },
    recalcPcnCountriesSelectedCount() {
      // Count rows that have at least one PCN country selected
      const count = (this.rows || []).reduce((acc, r) => {
        return (
          acc +
          (Array.isArray(r.pcnCountries) && r.pcnCountries.length > 0 ? 1 : 0)
        );
      }, 0);
      this.pcnCountriesSelectedCount = count;
    },
    formatUfiInput(row) {
      if (row.pcnUfi) {
        // Remove any non-alphanumeric characters and convert to uppercase
        let cleaned = row.pcnUfi.replace(/[^A-Z0-9]/gi, "").toUpperCase();

        // Add hyphens in the correct positions
        if (cleaned.length > 0) {
          let formatted = "";
          for (let i = 0; i < cleaned.length && i < 16; i++) {
            if (i > 0 && i % 4 === 0) {
              formatted += "-";
            }
            formatted += cleaned[i];
          }
          row.pcnUfi = formatted;
        }
      }
    },
  },
};
</script>